import { baseInMemoryFilterCompilers, createInMemoryFilterCompiler, createInMemoryWildcardCompilerSelector } from './InMemoryFilter.js';
// This should match the backend logica. Some things that might be possible in the 'in memory' compilers, are not possible in the SQL compilers.
// so that is why we don't support $elemMatch inside selectedChoices - this has been replaced with a wildcard selector instead.
export const recordAnswerItemFilterCompilers = {
    ...baseInMemoryFilterCompilers,
    selected: createInMemoryFilterCompiler('selected'),
    selectedChoice: createInMemoryFilterCompiler('selectedChoice', {
        ...baseInMemoryFilterCompilers,
        id: createInMemoryFilterCompiler('id'),
    }),
    selectedChoices: {
        ...baseInMemoryFilterCompilers,
        id: createInMemoryFilterCompiler('selectedChoices.*.id'),
    },
    value: createInMemoryFilterCompiler('value'),
};
export const recordAnswersFilterCompilers = {
    recordAnswers: createInMemoryFilterCompiler('recordAnswers', createInMemoryWildcardCompilerSelector(recordAnswerItemFilterCompilers)),
};
export const registrationInMemoryFilterCompilers = {
    ...baseInMemoryFilterCompilers,
    group: createInMemoryFilterCompiler('group', {
        ...baseInMemoryFilterCompilers,
        id: createInMemoryFilterCompiler('id'),
    }),
};
export const memberWithRegistrationsBlobInMemoryFilterCompilers = {
    ...baseInMemoryFilterCompilers,
    age: createInMemoryFilterCompiler('details.defaultAge'),
    gender: createInMemoryFilterCompiler('details.gender'),
    birthDay: createInMemoryFilterCompiler('details.birthDay'),
    missingData: createInMemoryFilterCompiler('details.missingData'),
    recordAnswers: createInMemoryFilterCompiler('details.recordAnswers', createInMemoryWildcardCompilerSelector(recordAnswerItemFilterCompilers)),
    registrations: createInMemoryFilterCompiler('registrations', registrationInMemoryFilterCompilers),
};
export const registerItemInMemoryFilterCompilers = {
    ...baseInMemoryFilterCompilers,
    member: createInMemoryFilterCompiler('member.patchedMember', memberWithRegistrationsBlobInMemoryFilterCompilers),
    groupPrice: createInMemoryFilterCompiler('groupPrice', {
        ...baseInMemoryFilterCompilers,
        id: createInMemoryFilterCompiler('id'),
    }),
    options: createInMemoryFilterCompiler('options', {
        ...baseInMemoryFilterCompilers,
        option: createInMemoryFilterCompiler('option', {
            ...baseInMemoryFilterCompilers,
            id: createInMemoryFilterCompiler('id'),
        }),
        optionMenu: createInMemoryFilterCompiler('optionMenu', {
            ...baseInMemoryFilterCompilers,
            id: createInMemoryFilterCompiler('id'),
        }),
        amount: createInMemoryFilterCompiler('amount'),
    }),
    ...recordAnswersFilterCompilers,
};
export const documentInMemoryFilterCompilers = {
    ...baseInMemoryFilterCompilers,
};
/**
 * These filters are used for filtering record categories/records in webshops. Try to keep it a bit limited as we'll have to support them for eternity.
 */
export const checkoutInMemoryFilterCompilers = {
    ...baseInMemoryFilterCompilers,
    items: createInMemoryFilterCompiler('cart.items', {
        ...baseInMemoryFilterCompilers,
        amount: createInMemoryFilterCompiler('amount'),
        product: createInMemoryFilterCompiler('product', {
            ...baseInMemoryFilterCompilers,
            id: createInMemoryFilterCompiler('id'),
        }),
        productPrice: createInMemoryFilterCompiler('productPrice', {
            ...baseInMemoryFilterCompilers,
            id: createInMemoryFilterCompiler('id'),
        }),
    }),
    checkoutMethod: createInMemoryFilterCompiler('checkoutMethod', {
        ...baseInMemoryFilterCompilers,
        id: createInMemoryFilterCompiler('id'),
        type: createInMemoryFilterCompiler('type'),
    }),
    ...recordAnswersFilterCompilers,
};
export const receivableBalanceObjectContactInMemoryFilterCompilers = {
    ...baseInMemoryFilterCompilers,
    meta: createInMemoryFilterCompiler('meta', {
        ...baseInMemoryFilterCompilers,
        responsibilityIds: createInMemoryFilterCompiler('responsibilityIds'),
    }),
};
export const organizationItemInMemoryFilterCompilers = {
    ...baseInMemoryFilterCompilers,
    tags: createInMemoryFilterCompiler('meta.tags'),
};
export const eventNotificationsInMemoryFilterCompilers = {
    ...baseInMemoryFilterCompilers,
    ...recordAnswersFilterCompilers,
};
export const paymentFilterCompilers = {
    ...baseInMemoryFilterCompilers,
    paidAt: createInMemoryFilterCompiler('paidAt'),
    method: createInMemoryFilterCompiler('method'),
    price: createInMemoryFilterCompiler('price'),
    transferDescription: createInMemoryFilterCompiler('transferDescription'),
};
export const privateOrderFilterCompilers = {
    ...baseInMemoryFilterCompilers,
    // Generic filtering
    id: createInMemoryFilterCompiler('id'),
    timeSlotEndTime: createInMemoryFilterCompiler('data.timeSlot.endTime'),
    timeSlotStartTime: createInMemoryFilterCompiler('data.timeSlot.startTime'),
    webshopId: createInMemoryFilterCompiler('webshopId'),
    // The following fields are required for sorting
    // Make sure to implement all sorters here, for proper pagination
    createdAt: createInMemoryFilterCompiler('createdAt'),
    number: createInMemoryFilterCompiler('number'),
    status: createInMemoryFilterCompiler('status'),
    checkoutMethod: createInMemoryFilterCompiler('data.checkoutMethod.type'),
    checkoutMethodId: createInMemoryFilterCompiler('data.checkoutMethod.id'),
    discountCodes: {
        ...baseInMemoryFilterCompilers,
        code: createInMemoryFilterCompiler('data.discountCodes.*.code'),
    },
    timeSlotDate: createInMemoryFilterCompiler('data.timeSlot.date'),
    validAt: createInMemoryFilterCompiler('validAt'),
    name: createInMemoryFilterCompiler('data.customer.name'),
    email: createInMemoryFilterCompiler('data.customer.email'),
    phone: createInMemoryFilterCompiler('data.customer.phone'),
    totalPrice: createInMemoryFilterCompiler('data.totalPrice'),
    amount: createInMemoryFilterCompiler('data.amount'),
    timeSlotTime: createInMemoryFilterCompiler('data.timeSlot.timeIndex'),
    location: createInMemoryFilterCompiler('data.locationName'),
    // Other (no sorters)
    items: createInMemoryFilterCompiler('data.cart.items', {
        ...baseInMemoryFilterCompilers,
        amount: createInMemoryFilterCompiler('amount'),
        product: createInMemoryFilterCompiler('product', {
            ...baseInMemoryFilterCompilers,
            id: createInMemoryFilterCompiler('id'),
        }),
        productPrice: createInMemoryFilterCompiler('productPrice', {
            ...baseInMemoryFilterCompilers,
            id: createInMemoryFilterCompiler('id'),
        }),
    }),
    amountToPay: createInMemoryFilterCompiler('amountToPay'),
    payments: createInMemoryFilterCompiler('payments', paymentFilterCompilers),
};
export const privateOrderWithTicketsFilterCompilers = {
    ...privateOrderFilterCompilers,
    ticketScanStatus: createInMemoryFilterCompiler('ticketScanStatus'),
    ticketScannedAt: createInMemoryFilterCompiler('ticketScannedAt'),
    ticketCount: createInMemoryFilterCompiler('tickets.length'),
};
//# sourceMappingURL=inMemoryFilterDefinitions.js.map